import { NgModule } from '@angular/core';
import { GetSanitizedHtmlPipe, TruncatePipe, GetSafeUrlPipe } from './pipes.component';

@NgModule({
    imports: [],
    declarations: [GetSanitizedHtmlPipe, TruncatePipe, GetSafeUrlPipe],
    exports: [GetSanitizedHtmlPipe, TruncatePipe, GetSafeUrlPipe],
})
export class PipesModule {}
